__turbopack_context__.v({
  "hoverImage": "_4VbiFG_hoverImage",
  "translucentHoverOverlay": "_4VbiFG_translucentHoverOverlay",
  "videoIcon": "_4VbiFG_videoIcon",
});
